import { render, staticRenderFns } from "./Staking.vue?vue&type=template&id=60275ec7&scoped=true&"
import script from "./Staking.vue?vue&type=script&lang=js&"
export * from "./Staking.vue?vue&type=script&lang=js&"
import style0 from "./Staking.vue?vue&type=style&index=0&id=60275ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60275ec7",
  null
  
)

export default component.exports